import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import CompanyFeatureFlagsEnum, { CompanyFeatureFlagsTips } from 'ab-enums/companyFeatureFlags.enum';

import { Button } from '@acceligentllc/storybook';

import Checkbox from 'af-components/Controls/Checkbox';
import CustomModal from 'af-components/CustomModal';
import SubmitButton from 'af-components/SubmitButton';

import * as CompanyActions from 'af-actions/companies';

import PreviewItem from '../../Shared/PreviewItem';

type OwnProps = {
	showModal: boolean;
	closeModal: () => void;
	areMaterialsEnabled: boolean;
};

type Props = OwnProps & ConnectedProps<typeof connector>;

const EnableMaterialsCompanyEdit: React.FC<Props> = ({ closeModal, showModal, areMaterialsEnabled, editMaterialsEnabled }) => {
	const [enableMaterials, setEnableMaterials] = React.useState(areMaterialsEnabled);

	const renderLabel = React.useCallback(() => {
		return (
			<PreviewItem
				checked={!!areMaterialsEnabled}
				hint={CompanyFeatureFlagsTips.materials}
				indent={false}
				label={CompanyFeatureFlagsEnum.areMaterialsEnabled}
				showCheckbox={false}
			/>
		);
	}, [areMaterialsEnabled]);

	const handleChange = React.useCallback((event) => {
		setEnableMaterials(event.target.checked);
	}, []);

	const handleSubmit = React.useCallback(async () => {
		await editMaterialsEnabled({ areMaterialsEnabled: enableMaterials });
		closeModal();
	}, [editMaterialsEnabled, enableMaterials, closeModal]);

	return (
		<CustomModal
			closeModal={closeModal}
			modalStyle="info"
			showModal={showModal}
			size="lg"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title="Edit Materials"
			/>
			<CustomModal.Body>
				<Checkbox
					handleChange={handleChange}
					isChecked={enableMaterials}
					label={renderLabel()}
				/>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={closeModal}
					style="secondary"
				/>
				<SubmitButton
					label="Save"
					onClick={handleSubmit}
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

function mapDispatchToProps() {
	return {
		editMaterialsEnabled: CompanyActions.editMaterialsEnabled,
	};
}

const connector = connect(null, mapDispatchToProps());

export default connector(EnableMaterialsCompanyEdit);
